<template>
  <div class="modal fade" tabindex="-1" role="dialog" v-on:keyup.enter="create">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">New User</h4>
      </div>
      <div class="modal-body">
        <form class="form-horizontal" submit="#">
          <div class="form-group" v-bind:class="{ 'has-error': this.$v.user.$dirty && this.$v.user.username.$invalid }" >
            <label class="control-label col-sm-3">Mail</label>
            <div class="col-sm-8">
              <input type="email" class="form-control" placeholder="john.doe@wwow.com" v-model="user.username"/>
            </div>
          </div>
          <div class="form-group" v-bind:class="{ 'has-error': this.$v.user.$dirty && this.$v.user.lastName.$invalid }" >
            <label class="control-label col-sm-3">Name</label>
            <div class="col-sm-8">
              <input type="email" class="form-control" placeholder="Doe" v-model="user.lastName"/>
            </div>
          </div>
          <div class="form-group" v-bind:class="{ 'has-error': this.$v.user.$dirty && this.$v.user.firstName.$invalid }" >
            <label class="control-label col-sm-3">Firstname</label>
            <div class="col-sm-8">
              <input type="email" class="form-control" placeholder="John" v-model="user.firstName"/>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-3">Role</label>
            <div class="radio col-sm-8">
              <label>
                <input type="radio" v-model="user.role" value="WWOW_USER">
                Utilisateur
              </label>
            </div>
            <div class="radio col-sm-offset-3 col-sm-8">
              <label>
                <input type="radio" v-model="user.role" value="WWOW_ADMIN">
                Administrateur
              </label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
        <button v-on:click="create" type="button" class="btn btn-danger">Create</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    name: 'NewCaseModal',
    data () {
      return {
        user: {
          username: null,
          firstName: null,
          lastName: null,
          role: 'WWOW_USER'
        }
      }
    },
    validations: {
      user: {
        username: {
          required, email
        },
        firstName: {
          required
        },
        lastName: {
          required
        }
      }
    },
    methods: {
      create () {
        this.$v.user.$touch()
        if (!this.$v.user.$invalid) {
          window.jQuery('#NewUserModal').modal('hide')
          this.$emit('create', this.user)
          this.$v.user.$reset()
          this.user = {
            username: null,
            firstName: null,
            lastName: null,
            role: 'WWOW_USER'
          }
        }
      }
    }
  }
  
</script>



// WEBPACK FOOTER //
// NewUserModal.vue?c0817b02